import "core-js/stable"
import "regenerator-runtime/runtime"

import "../stylesheets/application.scss"
import "../stylesheets/custom_template.scss"

import {setTimezoneCookie} from "@lib/helpers"

require.context("../images", true, /\.(png|jpg|jpeg|svg)$/)

const componentRequireContext = require.context("components", true)
const ReactRailsUJS = require("react_ujs")
ReactRailsUJS.useContext(componentRequireContext)

import Rails from "rails-ujs" // または "@rails/ujs"
Rails.start()
window.Rails = Rails // global → window に変更

import moment from "moment-timezone"
moment.locale("ja")
moment.tz.setDefault(moment.tz.guess(true))
window.moment = moment // グローバルで使う場合のみ

import AgoraRTC from "agora-rtc-sdk-ng"
window.AgoraRTC = AgoraRTC // これが必須

setTimezoneCookie()

const fonts = require.context("../fonts", true, /\.(woff|woff2|eot|ttf|otf)$/)
fonts.keys().forEach(fonts)
